import classNames from 'classnames';
import React from 'react';

import { MenuItemProps } from './types';

export const Menu = ({
  children,
  className = '',
  ...otherProps
}: React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>): JSX.Element => {
  const classNameProp = classNames({
    'p-6 flex-col inline-flex shadow-sm rounded-md w-full p-3': true,
    [className]: !!className,
  });
  return (
    <div className={classNameProp} {...otherProps}>
      {children}
    </div>
  );
};

export function MenuItem({
  children,
  className = '',
  icon,
  iconRight,
  isActive,
  isHighlighted = false,
  ...otherProps
}: MenuItemProps): JSX.Element {
  const classNameProp = classNames({
    'px-8 py-7 rounded-sm min-w-btn-lg hover:bg-gray-100 cursor-pointer align-middle flex': true,
    'bg-gray-100': isHighlighted,
    'active:bg-gray-300 text-sm': !!icon,
    'active:text-primary-500 font-medium text-xs': !icon,
    'text-primary-500 bg-gray-100': isActive,
    [className]: !!className,
  });
  return (
    <div className={classNameProp} {...otherProps}>
      {icon ? <span className="text-gray-500 mr-8 mt-2 align-middle">{icon}</span> : null}
      {children}
      {iconRight ? (
        <span className="text-gray-500 ml-8 self-center ml-auto">{iconRight}</span>
      ) : null}
    </div>
  );
}

export function MenuItemTwo({
  children,
  className = '',
  icon,
  iconRight,
  isActive,
  isHighlighted = false,
  ...otherProps
}: MenuItemProps): JSX.Element {
  const classNameProp = classNames({
    'px-8 py-7 rounded-sm min-w-btn-lg cursor-pointer align-middle': true,
    'bg-gray-100': isHighlighted,
    'active:bg-gray-300 text-sm': !!icon,
    'active:text-primary-500 font-medium text-xs': !icon,
    'text-primary-500 bg-gray-100': isActive,
    [className]: !!className,
  });
  return (
    <div className={classNameProp} {...otherProps}>
      {icon ? <span className="text-gray-500 mr-8 align-middle">{icon}</span> : null}
      {children}
      {iconRight ? <span className="text-gray-500 ml-8 align-middle">{iconRight}</span> : null}
    </div>
  );
}
